import React from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'

const ULDInfoDisplay = ({ uldColumns, uldInfoDetails }) => {
    //for multilingual
    const [t] = useTranslation(['labels'])
    return (
        <div className='uldInfo-card-wrapper'>
            {uldInfoDetails && uldInfoDetails.length > 0 ? (
                uldInfoDetails.map((uldInfo, uldInfoIndex) => (
                    <div className="uldInfo-card" key={uldInfoIndex}>
                        <div className="uldInfo-row">
                            <div className="uldInfo-col fixed-col-width">
                                <div className="uldInfo-heading">{t(uldColumns[0])}</div>
                                <div className="uldInfo-data">{uldInfo.uldType}</div>
                            </div>
                            <div className="uldInfo-col fixed-col-width">
                                <div className="uldInfo-heading">{t(uldColumns[1])}</div>
                                <div className="uldInfo-data">{uldInfo.numberOfUlds}</div>
                            </div>
                            <div className="uldInfo-col fixed-col-width">
                                <div className="uldInfo-heading">{t(uldColumns[2])}</div>
                                <div className="uldInfo-data">{uldInfo.numberOfUlds * uldInfo.uldWeight}</div>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className="uldInfo-no-data">{t('NO_DATA')}</div>
            )}
        </div>
    )
}

export default ULDInfoDisplay